import { z } from 'zod'
import { oc } from '@orpc/contract'
import { outgoingFaxMessageId } from './link-outgoing-fax.contract'

/**
 * The care tasks a sent fax has been linked to (PD-1606), for the Sent tab.
 * Reads the identifier stamped at link time, so it costs one search rather than
 * the board-and-item scan the fax inbox summaries do.
 */
export const outgoingFaxLinks = oc
  .route({ method: 'GET', path: '/v2/fax-tasks/outgoing-links/{messageId}' })
  .input(z.object({ messageId: outgoingFaxMessageId }))
  .output(
    z.object({
      tasks: z.array(
        z.object({
          itemId: z.string(),
          boardId: z.string(),
          boardName: z.string(),
          name: z.string(),
          // Derived from the board's status column, so the page can grey out a
          // finished task without a second request.
          status: z.string().nullable(),
          done: z.boolean(),
          // The link's own note, so the Sent page can prefill an edit without a
          // second request. Null when the link carries no note.
          note: z.string().nullable(),
        }),
      ),
    }),
  )
